import { IOutput, IPackage } from '@hackforplay/assets';

export const getScopeNames = (assetPackage: IPackage, button: IOutput | null) =>
  button && button.scopes
    ? button.scopes
        .map(scopeIndex => assetPackage.scopes[scopeIndex])
        .filter(s => s)
        .map(s => s.name)
    : [];
